import React__default from 'react';
import classnames from 'classnames';

const ImageZoom = ({ children , onZoom  })=>{
    var ref;
    const ref1 = React__default.useRef(null);
    const [zooming, setZooming] = React__default.useState(false);
    const handleMouseMove = (e)=>{
        if (e.target instanceof Element) {
            const { left , top , width , height  } = e.target.getBoundingClientRect();
            const x = Math.round((e.clientX - left) / width * 100);
            const y = Math.round((e.clientY - top) / height * 100);
            // We update the styles using a ref to directly manipulate the DOM
            // This way we we don't have to change state for every mouse movement, which would cause a lot of rerenders
            if (ref1.current) {
                ref1.current.style.transformOrigin = `${x}% ${y}%`;
            }
        }
    };
    const resetZoom = ()=>{
        setZooming(false);
        if (ref1.current) {
            ref1.current.style.transformOrigin = `0% 0%`;
        }
    };
    const enableZoom = ()=>{
        setZooming(true);
        onZoom();
    };
    const transformOrigin = (ref1 === null || ref1 === void 0 ? void 0 : (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.style.transformOrigin) || '0% 0%';
    return /*#__PURE__*/ React__default.createElement("div", {
        onMouseEnter: enableZoom,
        onMouseLeave: resetZoom,
        onMouseMove: handleMouseMove,
        className: classnames('image-zoom', {
            'image-zoom--hover': zooming
        }),
        "data-t": "image-zoom"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "image-zoom__img",
        "data-t": "zoom__image",
        style: {
            transformOrigin
        },
        ref: ref1
    }, children));
};

export { ImageZoom };
//# sourceMappingURL=ImageZoom.js.map
